// extracted by mini-css-extract-plugin
export var locationCard = "_em-0";